import type { ListKind } from "@home/shared";

const ru = {
  lists: "Списки",
  newList: "Новый список",
  noListsTitle: "Списков пока нет",
  noLists: "Создайте новый список или начните по шаблону ниже.",
  name: "Название",
  type: "Тип",
  onlyMe: "Только для меня",
  create: "Создать",
  cancel: "Отмена",
  save: "Сохранить",
  delete: "Удалить",
  useTemplate: "Создать список",
  addItem: "Добавить позицию…",
  bought: "Куплено",
  empty: "Список пуст — добавьте первую позицию",
  qty: "Кол-во",
  unit: "Ед.",
  comment: "Комментарий",
  photo: "Фото",
  addPhoto: "Добавить фото",
  removePhoto: "Убрать фото",
  uploading: "Загрузка…",
  photoOffline: "Фото можно добавить только при подключении к интернету",
  saveAsTemplate: "Сохранить как шаблон",
  clearBought: "Убрать купленные",
  uncheckAll: "Снять все отметки",
  deleteList: "Удалить список",
  confirmDelete: "Удалить список «{name}»?",
  rename: "Переименовать",
  private: "личный",
  offline: "Нет сети — изменения сохранятся и отправятся позже",
  syncing: "Синхронизация…",
  pending: "Не отправлено: {n}",
  unauthorized: "Нет доступа. Откройте приложение из бота и вступите в семью (/start).",
  loading: "Загрузка…",
  rejected: "Изменение отклонено сервером",
  checkedBy: "купил(а) {name}",
  "kind.grocery": "Продукты",
  "kind.pharmacy": "Аптека",
  "kind.kids": "Детское",
  "kind.other": "Прочее",
  savedAsTemplate: "Шаблон сохранён",
  units: "шт,кг,г,л,уп",
  goalsTab: "Копилки",
  balanceTotal: "На счетах",
  incomeL: "Доходы",
  expenseL: "Расходы",
  netL: "Итог",
  savedShare: "Отложено {p}% дохода",
  overspent: "Расходы выше доходов",
  cmpFull: "Сравнение — с прошлым месяцем",
  cmpPartial: "Сравнение — с 1–{d} числами прошлого месяца",
  accountsTitle: "Счета и карты",
  personalAcc: "личный",
  usdRate: "Курс ЦБ: 1 $ = {rate}",
  noRateShort: "нет курса ЦБ",
  fxMissing: "Нет курса ЦБ — суммы в долларах не пересчитаны в сумы и не вошли в итог.",
  fxMissingDebts: "Долги в долларах не вошли в суммы: нет курса ЦБ.",
  aiTitle: "Советы ИИ",
  aiEmpty: "Claude разберёт доходы, расходы и накопления семьи и подскажет, где сэкономить, как больше откладывать и увеличить доход.",
  aiGet: "Получить советы",
  aiRefresh: "Обновить",
  aiLoading: "Анализирую финансы… это может занять до минуты",
  aiAt: "Разбор от {date}",
  aiLimit: "Новый разбор — раз в месяц",
  aiNext: "Следующий разбор — с {date}",
  "health.good": "Всё хорошо",
  "health.ok": "Есть над чем поработать",
  "health.risk": "Нужно внимание",
  impact: "≈ {amount} в месяц",
  dailyTitle: "Расходы по дням",
  categoriesTitle: "На что уходят деньги",
  hiddenPersonal: "Личные расходы других",
  hiddenInTotals: "В итогах есть личные операции других членов семьи ({parts}) — в списке операций их не видно",
  topItems: "Что покупаете больше всего",
  topPlaces: "Где тратите",
  recentTitle: "Последние операции",
  allOps: "Все операции за месяц",
  upcoming: "Ближайшие платежи",
  noData: "Как только появятся записи, здесь будет видно, на что уходят деньги.",
  offlineData: "Нет сети — показаны данные от {time}",
  loadError: "Не удалось загрузить данные",
  times: "{n} раз|{n} раза|{n} раз",
  transferL: "Перевод",
  saved: "накоплено",
  until: "до {date}",
  "err.insight_limit": "Разбор доступен раз в месяц — следующий с 1-го числа",
  "err.insight_no_data": "Пока мало данных: запишите несколько доходов и расходов",
  "err.forbidden": "Нет доступа",
  "err.bad_args": "Проверьте введённые данные",
  "err.not_found": "Не найдено — возможно, уже удалено",
  "err.no_account": "Нет счёта в этой валюте — добавьте его в «Ещё → Счета»",
  "err.no_rate": "Нет курса доллара от ЦБ — запишите сумму в сумах или попробуйте позже",
  "err.amount_required": "Укажите сумму",
  "err.blocked": "Доступ к сервису закрыт",
  receipt: "Чек",
  checkReceipt: "Сверить с чеком",
  scanQr: "Сканировать QR-код чека",
  scanPrompt: "Наведите камеру на QR-код чека",
  receiptPhoto: "Сфотографировать чек",
  pasteLink: "Ссылка из QR-кода",
  check: "Проверить",
  reading: "Читаю чек…",
  matching: "Сверяю со списком…",
  extra: "Не было в списке",
  missing: "Не куплено",
  total: "Итого",
  saveMark: "Сохранить расход и отметить купленное",
  saveOnly: "Только сохранить расход",
  receiptSaved: "Расход сохранён",
  alreadySaved: "Этот чек уже сохранён",
  needOnline: "Для чека нужен интернет",
  "err.receipt_qr_invalid": "Это не QR-код фискального чека",
  "err.receipt_not_found": "Налоговая не нашла этот чек. Попробуйте позже или сфотографируйте его",
  "err.receipt_unavailable": "Сервис проверки чеков недоступен — сфотографируйте чек",
  "err.receipt_unreadable": "Не удалось прочитать чек на фото",
  "err.receipt_refund": "Это чек возврата — расходом не записывается",
  "err.receipt_is_payment": "Это скриншот перевода, а не чек — отправьте его боту",
  "err.generic": "Что-то пошло не так",
  opsTab: "История",
  moreTab: "Ещё",
  expense: "Расход",
  income: "Доход",
  transfer: "Перевод",
  addOp: "Записать",
  newOp: "Новая запись",
  amount: "Сумма",
  category: "Категория",
  allCategories: "Все",
  toWhom: "Кому",
  commentPh: "Комментарий: магазин, что купили",
  date: "Дата",
  today: "Сегодня",
  yesterday: "Вчера",
  otherDate: "Другая",
  personalOp: "🔒 Личная — видна только мне",
  byPhrase: "✨ Написать фразой",
  byForm: "← Заполнить вручную",
  phrasePh: "Например: такси 25 тысяч и кофе 18 000",
  phraseHint: "Можно несколько операций сразу — как в сообщении боту",
  recognize: "Распознать",
  recognizing: "Распознаю… несколько секунд",
  saveAll: "Сохранить ({n})",
  notRecognized: "Не получилось распознать. Напишите сумму и на что потрачено",
  noOtherAdults: "Переводить некому: в семье нет других взрослых",
  savedOk: "Сохранено",
  deletedOk: "Удалено",
  fillAmount: "Введите сумму",
  pickCategory: "Выберите категорию",
  pickMember: "Выберите, кому перевод",
  fillName: "Введите название",
  needOnlineOp: "Нет сети — попробуйте, когда появится интернет",
  opDetails: "Операция",
  author: "Записал(а)",
  source: "Источник",
  "src.manual": "Вручную в приложении",
  "src.text": "Текстом (разбор ИИ)",
  "src.voice": "Голосовое сообщение",
  "src.photo": "Скриншот или фото",
  "src.receipt": "Чек",
  "src.recurring": "Регулярный платёж",
  deleteOp: "Удалить операцию",
  confirmDeleteOp: "Удалить эту операцию? Баланс пересчитается.",
  personalMark: "Личная",
  you: "вы",
  all: "Все",
  incomes: "Доходы",
  expenses: "Расходы",
  transfers: "Переводы",
  noOps: "За этот месяц операций нет",
  noOpsHint: "Записывайте расходы кнопкой ниже или просто пишите боту",
  firstOp: "Записать операцию",
  newGoal: "Новая копилка",
  goalName: "На что копим",
  goalNamePh: "Например: велосипед",
  goalTarget: "Сколько нужно",
  deadlineOpt: "Срок (необязательно)",
  goalOwner: "Чья копилка",
  familyGoal: "Семейная",
  myGoal: "Моя",
  topUp: "Пополнить",
  withdraw: "Снять",
  goalReached: "🎉 Цель достигнута!",
  left: "осталось {amount}",
  createGoal: "Создать копилку",
  noGoalsYet: "Копилок пока нет",
  noGoalsHint: "Копите всей семьёй: велосипед, отпуск, подарок",
  noGoalsChild: "Копи на мечту: создай копилку и откладывай понемногу",
  "err.goal_insufficient": "В копилке нет столько денег",
  recurringTitle: "Регулярные платежи",
  addRecurring: "Добавить платёж",
  recurringName: "Что оплачиваем",
  recurringNamePh: "Например: интернет",
  dayOfMonth: "Какого числа",
  everyMonth: "каждое {d}-е число",
  nextOn: "следующий {date}",
  noRecurring: "Платежей нет. Добавьте интернет, садик, кредит — бот напомнит заранее",
  confirmDeleteRecurring: "Удалить платёж «{name}»?",
  manage: "Управлять",
  addAccount: "Добавить счёт",
  accountName: "Название",
  accountNamePh: "Например: Humo, наличные",
  currency: "Валюта",
  personalAccount: "🔒 Личный — виден только мне",
  familyTitle: "Семья",
  "role.admin": "администратор",
  "role.adult": "взрослый",
  "role.child": "ребёнок",
  inviteAdult: "Пригласить взрослого",
  inviteChild: "Пригласить ребёнка",
  inviteText: "Присоединяйся к нашей семье в боте учёта расходов",
  inviteReady: "Отправьте ссылку члену семьи. Действует до {date}",
  inviteCode: "Или код для бота: {code}",
  share: "Поделиться",
  copy: "Скопировать",
  copied: "Скопировано",
  onlyAdminInvites: "Приглашать может администратор семьи",
  language: "Язык",
  openBot: "Открыть чат с ботом",
  help: "Как пользоваться",
  devPanel: "Панель разработчика",
  sectionMoney: "Деньги",
  sectionFamily: "Семья и настройки",
  "help.add.t": "Записать расход или доход",
  "help.add.d": "На главной — большая кнопка «＋ Записать». В боте достаточно написать «такси 25 000» или отправить голосовое.",
  "help.phrase.t": "Фразой, как боту",
  "help.phrase.d": "В форме записи нажмите «✨ Написать фразой» — ИИ сам разберёт сумму и категорию, вы проверите и сохраните.",
  "help.receipt.t": "Чеки",
  "help.receipt.d": "Отправьте боту фото чека или его QR-код. В списке покупок кнопка 🧾 сверит чек со списком.",
  "help.lists.t": "Списки покупок",
  "help.lists.d": "Вкладка «Списки»: общий список для всей семьи, отметки видны всем сразу, работает и без интернета. Готовые наборы — в разделе «Начать по шаблону».",
  "help.goals.t": "Копилки и платежи",
  "help.goals.d": "Копилки, регулярные платежи и карманные деньги детей — во вкладке «Ещё». Бот напомнит о платеже за день.",
  "help.sync.t": "Бот и приложение — одно целое",
  "help.sync.d": "Всё, что записано в боте, сразу видно здесь, и наоборот. Отменить последнюю запись в боте — /undo.",
  adminTitle: "Панель разработчика",
  adminOverview: "Обзор",
  adminFamilies: "Семьи",
  adminUsers: "Люди",
  usersL: "Пользователи",
  familiesL: "Семьи",
  activeToday: "Сегодня",
  active7: "7 дней",
  active30: "30 дней",
  activeUsers: "Активные пользователи",
  newUsers7: "+{n} за неделю",
  blockedN: "заблокировано: {n}",
  active7Families: "активны за неделю: {n}",
  llmToday: "ИИ сегодня",
  llm30: "ИИ за 30 дней",
  callsN: "{n} вызов|{n} вызова|{n} вызовов",
  tokensLine: "токены: {in} вход · {out} выход · {cache} из кэша",
  byPurpose: "По задачам",
  byModel: "По моделям",
  "purpose.parse": "Разбор сообщений",
  "purpose.ocr": "Фото и чеки",
  "purpose.match": "Сверка чека со списком",
  "purpose.advice": "Советы ИИ",
  activity30: "Активность за 30 дней",
  metricActive: "Люди",
  metricRequests: "Запросы",
  metricTx: "Операции",
  metricCost: "$ ИИ",
  contentTitle: "Данные",
  contentLine: "Операций: {tx} · чеков: {r} · списков: {l} · позиций: {i}",
  block: "Заблокировать",
  unblock: "Разблокировать",
  blockedBadge: "заблокирован",
  blockFamily: "Заблокировать семью",
  unblockFamily: "Разблокировать семью",
  confirmBlockUser: "Заблокировать {name}? Бот и приложение перестанут для него работать.",
  confirmBlockFamily: "Заблокировать всех в семье «{name}»?",
  lastSeen: "был(а) {when}",
  neverSeen: "ещё не заходил(а)",
  noFamilyL: "без семьи",
  searchPh: "Поиск по имени или @username",
  developerBadge: "разработчик",
  requests30: "запросов за 30 дней: {n}",
  membersN: "{n} чел.",
  txN: "операций: {n}",
  activeAgo: "активность {when}",
  noActivity: "активности ещё не было",
  updatedAt: "Обновлено {time}",
  justNow: "только что",
  minAgo: "{n} мин назад",
  hoursAgo: "{n} ч назад",
  notFound: "Ничего не найдено",
  appTitle: "Семейный бюджет",
  debtsTitle: "Кредиты и рассрочки",
  debtsShort: "Долги",
  addDebt: "Добавить кредит или рассрочку",
  newDebt: "Новый долг",
  noDebts: "Кредитов и рассрочек нет",
  noDebtsHint: "Добавьте их — приложение посчитает остаток, напомнит о платежах и покажет, когда долги закроются",
  "debtKind.credit": "Кредит",
  "debtKind.microloan": "Микрозайм",
  "debtKind.installment": "Рассрочка",
  "debtKind.card": "Кредитная карта",
  "debtKind.personal": "Долг знакомым",
  debtNamePh: "Например: Anorbank, телефон в рассрочку",
  lender: "Кредитор (необязательно)",
  debtPrincipal: "Сумма по договору",
  rate: "Ставка, % годовых",
  scheduleKind: "Как платите",
  "sched.annuity": "Равными платежами",
  "sched.differentiated": "Убывающими",
  "sched.equal": "Частями без %",
  "sched.fixed": "Знаю платёж",
  termMonths: "Срок, месяцев",
  monthlyPayment: "Платёж в месяц",
  startDate: "Дата начала",
  paymentDay: "День платежа",
  disbursed: "Деньги пришли на счёт",
  disbursedHint: "Сумма добавится к остатку счёта, но доходом не считается",
  personalDebt: "🔒 Личный — виден только мне",
  preview: "Платёж ≈ {payment} · {count} мес. · переплата {interest}",
  previewPast: "Уже прошло платежей: {n} — отметим их погашенными без записи расходов",
  remainingL: "Осталось",
  monthlyL: "Платежи в месяц",
  loadL: "Нагрузка: {pct}% дохода",
  "load.ok": "в норме",
  "load.high": "высокая",
  "load.danger": "опасная",
  debtFree: "Без долгов — с {date}",
  overdueN: "Просрочено платежей: {n}",
  nextPaymentL: "Ближайший платёж",
  paidOf: "Оплачено {paid} из {total}",
  payNext: "Оплатить {amount}",
  payOther: "Другая сумма",
  extraPay: "Досрочное погашение",
  extraTerm: "Сократить срок",
  extraPayment: "Уменьшить платёж",
  extraHint: "Сократить срок — меньше переплата. Уменьшить платёж — легче каждый месяц.",
  scheduleTitle: "График платежей",
  historicPaid: "до учёта",
  deleteDebt: "Удалить долг",
  confirmDeleteDebt: "Удалить «{name}»? Записанные платежи останутся в операциях.",
  debtClosed: "🎉 Долг закрыт!",
  interestLeft: "Ещё переплатите: {amount}",
  endDateL: "последний платёж {date}",
  toDebt: "→ В кредиты",
  overdueL: "просрочен",
  personalDebtsOthers: "🔒 Личные долги других: {amount}",
  "err.debt_payment_too_small": "Платёж меньше процентов — так долг не закроется. Проверьте сумму и ставку",
  "err.debt_nothing_due": "По этому долгу нет платежей к оплате",
  "err.debt_closed": "Долг уже закрыт",
  "err.already_handled": "Уже отмечено",
  payoffTitle: "План погашения",
  payoffIntro: "Сколько вы готовы доплачивать к обязательным платежам? Покажем, когда закроются долги и сколько сэкономите на процентах.",
  payoffExtra: "Доплата в месяц",
  payoffNoExtra: "Без доплаты",
  avalanche: "Лавина",
  snowball: "Снежный ком",
  avalancheHint: "Сначала самый дорогой долг — меньше всего переплата.",
  snowballHint: "Сначала самый маленький долг — быстрее первые победы, проще не бросить.",
  payoffFree: "Без долгов — {date}",
  payoffSaved: "На {months} мес. раньше и на {amount} меньше процентов, чем без доплаты",
  payoffInterest: "Проценты за весь срок: {amount}",
  payoffNever: "При таких платежах долги не закрываются — платёж меньше процентов. Увеличьте доплату.",
  incomeTitle: "Доход семьи",
  incomeHint: "Примерный доход в месяц — для расчёта нагрузки по кредитам и советов, пока истории операций мало.",
  incomePerMonth: "Доход в месяц",
  incomeDay: "Когда приходит зарплата",
  incomeDayNone: "Нет точного дня",
  setupTitle: "Настройте за минуту",
  setupHint: "Так анализ, нагрузка по кредитам и советы будут точными с первого дня.",
  setupIncome: "Доход семьи",
  setupDebts: "Кредиты и рассрочки",
  setupRecurring: "Регулярные платежи",
  setupDone: "Готово",
  phraseDebt: "Похоже на новый кредит или рассрочку — добавьте его в «Ещё → Кредиты и рассрочки» или напишите эту фразу боту.",
  noOpsFilter: "Операций этого типа за месяц нет",
  pickDay: "Выберите число месяца",
  youCap: "Вы",
  copyFailed: "Не удалось скопировать — выделите текст вручную",
  noListsChild: "Здесь будут твои списки: что купить или взять с собой.",
  "help.child.goals.d": "Во вкладке «Мои деньги» — твой кошелёк и копилки. Записывай траты и подарки, откладывай понемногу — так копить легче всего.",
  "help.child.sync.d": "То же самое можно делать в боте кнопками внизу чата.",
  homeTab: "Главная",
  spentIn: "Расходы за {month}",
  morePct: "на {p}% больше, чем месяц назад",
  lessPct: "на {p}% меньше, чем месяц назад",
  overspentBy: "Расходы больше доходов на {amount}",
  reportTitle: "Отчёт",
  reportMonth: "Отчёт за месяц",
  noOpsYet: "Пока ничего не записано",
  noOpsYetHint: "Нажмите «Записать» или просто напишите боту: «хлеб 8 тысяч».",
  detailsTitle: "Дата, комментарий",
  change: "Изменить",
  sharedShort: "общая",
  personalShort: "🔒 личная",
  listsTitle: "Списки покупок",
  startFromTemplate: "Начать по шаблону",
  start: "Начать",
  "help.report.t": "Отчёт",
  "help.report.d": "На главной нажмите «На что уходят деньги» или откройте «Ещё → Отчёт за месяц»: категории, графики, цены на ваши покупки, магазины и советы ИИ.",
  pricesTitle: "Цены",
  pricesEmpty: "Цены появятся, когда сохраните чек или напишете покупку с весом: «картошка 3 кг 24 тысячи».",
  pricesAll: "Все товары ({n})",
  inflationUp: "Ваши цены выросли на {p}% к прошлым месяцам",
  inflationDown: "Ваши цены снизились на {p}% к прошлым месяцам",
  inflationSame: "Ваши цены не изменились к прошлым месяцам",
  inflationHint: "Покупки этого месяца по ценам трёх прошлых. Товаров в расчёте: {n}",
  priceUp: "↑ {p}% за месяц",
  priceDown: "↓ {p}% за месяц",
  cheaperAt: "дешевле: {store} — {price}",
  noStore: "без чека",
  unitKg: "кг",
  unitL: "л",
  unitPcs: "шт",
  perUnit: "Цена за 1 {unit}",
  whereCheaper: "Где дешевле за 3 месяца",
  purchasesTitle: "Покупки",
  boughtQty: "{qty} {unit} за {amount}",
  "purpose.products": "Справочник товаров",
  "purpose.weekly": "Итоги недели",
  savedOffline: "Нет сети — запишем, когда появится интернет",
  opsPending: "Ждут отправки записей: {n}",
  opsSent: "Записи без сети отправлены",
  opDropped: "Запись не сохранилась: {reason}",
  dueOn: "Срок: {date}",
  markPaid: "✅ Оплачено",
  markPaidHint: "«Оплачено» запишет расход {amount}, следующий платёж — через месяц.",
  skipOnce: "Пропустить этот раз",
  confirmSkip: "Пропустить «{name}» в этот раз? Расход не запишется.",
  paidOk: "Записали расход",
  skippedOk: "Пропущено",
  fridgeTitle: "Холодильник",
  menuTitle: "Меню на неделю",
  fridgeHave: "Дома есть",
  fridgeStale: "Куплено давно — проверьте",
  fridgeUsed: "Закончилось",
  fridgeUsedHint: "Нажмите на продукт, если он ещё есть.",
  fridgeEmpty: "Холодильник пуст",
  fridgeEmptyHint: "Сохраните чек из магазина или запишите покупку с продуктами: «молоко, хлеб, яйца 45 тысяч». Купленное появится здесь само — до отметки «Закончилось».",
  usedBtn: "Закончилось",
  toListBtn: "В список",
  addProduct: "Добавить продукт",
  productName: "Продукт",
  productNamePh: "Например: молоко",
  boughtToday: "куплено сегодня",
  boughtYesterday: "куплено вчера",
  boughtDaysAgo: "куплено {n} день назад|куплено {n} дня назад|куплено {n} дней назад",
  markedUsed: "Отмечено: закончилось",
  restored: "Вернули в холодильник",
  addedToList: "Добавлено в список «{name}»",
  groceryListName: "Продукты",
  menuListName: "Меню на неделю",
  cookIdeas: "Что приготовить?",
  ideasTitle: "Можно приготовить",
  ideasLoading: "Подбираем блюда — это 5–10 секунд…",
  ideasMore: "Другие варианты",
  ideaHave: "Есть: {list}",
  ideaMissing: "Докупить: {list}",
  minutesN: "{n} мин",
  menuEmptyHint: "Составим обед и ужин на 7 дней из того, что есть дома, и список того, что докупить.",
  wishesL: "Пожелания (необязательно)",
  wishesPh: "Например: без грибов, ребёнку 3 года",
  makeMenu: "Составить меню",
  remakeMenu: "Составить заново",
  menuLoading: "Составляем меню — это 10–20 секунд…",
  lunchL: "Обед",
  dinnerL: "Ужин",
  shoppingN: "Что докупить ({n})",
  toShoppingList: "В список покупок",
  weekdaysFull: "понедельник,вторник,среда,четверг,пятница,суббота,воскресенье",
  "err.pantry_empty": "Дома пока ничего не отмечено — сохраните чек или добавьте продукты",
  "err.ai_limit": "На сегодня идей хватит — попробуйте завтра",
  "err.ai_unavailable": "ИИ сейчас не ответил — попробуйте ещё раз через минуту",
  "purpose.cooking": "Что приготовить",
  "purpose.menu": "Меню на неделю",
  "help.cook.t": "Холодильник и меню",
  "help.cook.d": "«Ещё → Дом → Холодильник»: купленное по чекам появляется само, отмечайте «Закончилось». ИИ подскажет, что приготовить, и составит меню на неделю — недостающее одной кнопкой уйдёт в список покупок.",
  sectionHome: "Дом",
  "help.home.t": "Аптечка и гарантии",
  "help.home.d": "«Ещё → Дом»: лекарства со сроком годности и покупки с гарантией и фото чека. Бот напомнит за месяц до срока.",
  kitTitle: "Аптечка",
  warrantiesTitle: "Гарантии",
  kitEmpty: "Аптечка пуста",
  kitEmptyHint: "Добавьте лекарства со сроком годности — бот напомнит за месяц, когда срок подходит к концу.",
  warrantiesEmpty: "Гарантий пока нет",
  warrantiesEmptyHint: "Сохраните покупку с фото чека и сроком гарантии — бот напомнит за месяц до конца.",
  addMedicine: "Добавить лекарство",
  addWarranty: "Добавить гарантию",
  medicineName: "Лекарство",
  medicineNamePh: "Например: Нурофен детский",
  warrantyName: "Что купили",
  warrantyNamePh: "Например: Холодильник Artel",
  expiresMonth: "Годен до (как на упаковке)",
  boughtOnL: "Дата покупки",
  warrantyFor: "Гарантия",
  warrantyMonths: "{n} мес.",
  warrantyYears: "{n} год|{n} года|{n} лет",
  warrantyOther: "Другой срок",
  warrantyUntil: "Гарантия до {date}",
  untilDate: "До какого числа",
  fillBoughtOn: "Укажите дату покупки или выберите «Другой срок»",
  fillUntil: "Укажите, до какого числа гарантия",
  medicineNote: "Для чего, сколько осталось",
  medicineNotePh: "Например: от температуры, 1 упаковка",
  warrantyNote: "Где купили, сервис",
  warrantyNotePh: "Например: Mediapark, сервисный центр",
  warrantyPhoto: "Фото чека или талона",
  packPhoto: "Фото упаковки",
  expiredMedicine: "Просрочено",
  expiredWarranty: "Закончилась",
  inDaysN: "через {n} день|через {n} дня|через {n} дней",
  todayLast: "сегодня последний день",
  monthsLeftN: "ещё {n} мес.",
  usedUp: "Закончилось",
  confirmUsedUp: "Убрать «{name}» из аптечки?",
  confirmDeleteWarranty: "Удалить гарантию «{name}»?",
  expiredWarranties: "Закончились",
  photoTap: "Нажмите, чтобы открыть фото",
  pocketTab: "Мои деньги",
  walletTitle: "В кошельке",
  spendBtn: "Трата",
  saveBtn: "Отложить",
  giftBtn: "Мне дали",
  spendTitle: "Записать трату",
  giftTitle: "Тебе дали деньги",
  saveTitle: "Копилка",
  spendNote: "На что",
  spendNotePh: "Например: мороженое",
  giftNote: "От кого",
  giftNotePh: "Например: бабушка",
  toGoal: "Отложить",
  fromGoal: "Взять в кошелёк",
  pickGoal: "В какую копилку",
  allowanceEvery: "Карманные: {amount} {weekday}",
  allowanceNext: "следующие — {date}",
  weekdaysEvery: "по понедельникам,по вторникам,по средам,по четвергам,по пятницам,по субботам,по воскресеньям",
  weekdaysShort: "Пн,Вт,Ср,Чт,Пт,Сб,Вс",
  thisMonth: "В этом месяце",
  gotL: "Получено",
  spentL: "Потрачено",
  savedL: "Отложено",
  tipOfWeek: "Совет недели",
  pocketHistory: "Что было",
  pocketEmpty: "Здесь будут твои деньги",
  pocketEmptyHint: "Карманные, подарки и траты. Если у тебя уже есть деньги — нажми «Мне дали».",
  "pocket.give": "Карманные",
  "pocket.gift": "Подарок",
  "pocket.spend": "Трата",
  "pocket.saveIn": "В копилку «{name}»",
  "pocket.saveOut": "Из копилки «{name}»",
  goalPace: "По {amount} в неделю — ещё {n} неделю|По {amount} в неделю — ещё {n} недели|По {amount} в неделю — ещё {n} недель",
  inWallet: "В кошельке: {amount}",
  showAllN: "Показать все ({n})",
  confirmDeleteEntry: "Удалить запись «{what}»?",
  "err.pocket_insufficient": "В кошельке столько нет",
  "err.pocket_spent": "Эти деньги уже потрачены — сначала удалите траты",
  "err.pocket_currency": "Из кошелька можно откладывать только в копилку в сумах",
  pocketMoney: "Карманные деньги",
  noKids: "В семье пока нет детей. Пригласите ребёнка: «Ещё → Семья».",
  giveBtn: "Выдать",
  giveTitle: "Выдать карманные",
  giveHint: "Запишется расходом семьи «Дети» с общего счёта.",
  givenOk: "Выдано",
  allowanceTitle: "Каждую неделю",
  allowanceNone: "Карманные по расписанию не настроены",
  allowanceSetup: "Настроить",
  allowanceDay: "В какой день",
  allowanceTurnOff: "Выключить",
  allowanceHint: "Деньги придут ребёнку сами — бот сообщит и ему, и вам. В расходах семьи появится запись «Дети».",
  allowanceSaved: "Карманные настроены",
  allowanceOffOk: "Карманные выключены",
  stashAccount: "🐷 Заначка — видна только мне, не входит в общий остаток",
  defaultBadge: "основной",
  stashSection: "🐷 Заначка — не входит в общий остаток",
  balanceParts: "Из чего сложился остаток",
  partOpening: "Начальный остаток и сверки",
  partIncome: "Доходы",
  partExpense: "Расходы",
  partTransfersIn: "Переводы на счёт",
  partTransfersOut: "Переводы со счёта",
  partCredits: "Деньги кредитов",
  partGoals: "Отложено в копилки",
  reconcile: "Сверить остаток",
  reconcileHint: "Сколько на счёте на самом деле? Разница запишется в начальный остаток — доходы и расходы не изменятся.",
  actualBalance: "Остаток сейчас",
  reconciledOk: "Остаток сверен",
  negativeBalance: "На счёте минус (ушли в овердрафт)",
  renameAccount: "Переименовать",
  makeStash: "🐷 Сделать заначкой",
  unmakeStash: "Вернуть в общий остаток",
  stashOnOk: "Теперь это заначка",
  stashOffOk: "Счёт снова в общем остатке",
  accountOps: "Операции по счёту",
  noAccountOps: "По счёту пока нет операций",
  accountL: "Счёт",
  fromAccount: "С какого счёта",
  toAccount: "На какой счёт",
  transferMember: "👤 Члену семьи",
  transferOwn: "💳 Между счетами",
  received: "Сколько пришло",
  receivedHint: "Пусто — посчитаем по курсу ЦБ",
  commission: "Комиссия, если была",
  commissionNote: "комиссия",
  pickFromAccount: "Выберите, с какого счёта",
  pickToAccount: "Выберите, на какой счёт",
  moveAccount: "Перенести на другой счёт",
  movedOk: "Перенесено на «{name}»",
  receivedL: "Пришло",
  "err.account_currency": "Счёт в другой валюте — выберите счёт в валюте операции",
  "err.same_account": "Счёт «откуда» и «куда» — один и тот же",
  makePersonalOp: "🔒 Сделать личной",
  makeSharedOp: "👨‍👩‍👧 Сделать общей",
  madePersonalOk: "Теперь видна только вам",
  madeSharedOk: "Теперь видна семье",
  fridgeSoon: "Скоро закончится",
  lastsDays: "хватает на {n} день|хватает на {n} дня|хватает на {n} дней",
  dueSoon: "скоро закончится",
  dueNow: "пора докупить",
  suggestTitle: "Пора докупить",
  needToList: "Добавить в список покупок",
  versionLabel: "Версия {v}",
  versionStale: "На сервере уже {v} — закройте приложение и откройте заново",
  rhythmEvery: "Обычно покупаете раз в {n} день|Обычно покупаете раз в {n} дня|Обычно покупаете раз в {n} дней",
  rhythmLast: "в последний раз — {day}",
  rhythmNext: "снова — через {n} день|снова — через {n} дня|снова — через {n} дней",
  healthTitle: "Что это за продукт",
  healthHealthy: "🥦 Полезное",
  healthNeutral: "Обычное",
  healthUnhealthy: "🍭 Вредное",
  healthSaved: "Метка сохранена — только для вашей семьи",
  noPricesYet: "Цен пока нет: они появятся из чеков и фраз с суммой",
  basketTitle: "Что в корзине",
  basketHealthy: "Полезное",
  basketNeutral: "Обычное",
  basketUnhealthy: "Вредное",
  basketUsual: "обычно {p}%",
  basketMore: "🍭 Сладкого и вредного в корзине больше обычного.",
  basketLess: "🥦 Вредного меньше обычного.",
  basketHint: "Продукты за месяц по сумме — из чеков и фраз, где у продукта есть сумма.",
};

type Key = keyof typeof ru;

const uz: Record<Key, string> = {
  lists: "Ro'yxatlar",
  newList: "Yangi ro'yxat",
  noListsTitle: "Hozircha ro'yxatlar yo'q",
  noLists: "Yangi ro'yxat yarating yoki pastdagi shablondan boshlang.",
  name: "Nomi",
  type: "Turi",
  onlyMe: "Faqat men uchun",
  create: "Yaratish",
  cancel: "Bekor qilish",
  save: "Saqlash",
  delete: "O'chirish",
  useTemplate: "Ro'yxat yaratish",
  addItem: "Mahsulot qo'shish…",
  bought: "Sotib olindi",
  empty: "Ro'yxat bo'sh — birinchi mahsulotni qo'shing",
  qty: "Miqdori",
  unit: "Birl.",
  comment: "Izoh",
  photo: "Rasm",
  addPhoto: "Rasm qo'shish",
  removePhoto: "Rasmni olib tashlash",
  uploading: "Yuklanmoqda…",
  photoOffline: "Rasmni faqat internet bo'lganda qo'shish mumkin",
  saveAsTemplate: "Shablon sifatida saqlash",
  clearBought: "Sotib olinganlarni olib tashlash",
  uncheckAll: "Barcha belgilarni olib tashlash",
  deleteList: "Ro'yxatni o'chirish",
  confirmDelete: "«{name}» ro'yxati o'chirilsinmi?",
  rename: "Nomini o'zgartirish",
  private: "shaxsiy",
  offline: "Internet yo'q — o'zgarishlar saqlanadi va keyinroq yuboriladi",
  syncing: "Sinxronlanmoqda…",
  pending: "Yuborilmagan: {n}",
  unauthorized: "Ruxsat yo'q. Ilovani botdan oching va oilaga qo'shiling (/start).",
  loading: "Yuklanmoqda…",
  rejected: "O'zgarish server tomonidan rad etildi",
  checkedBy: "{name} oldi",
  "kind.grocery": "Oziq-ovqat",
  "kind.pharmacy": "Dorixona",
  "kind.kids": "Bolalar uchun",
  "kind.other": "Boshqa",
  savedAsTemplate: "Shablon saqlandi",
  units: "dona,kg,g,l,qadoq",
  goalsTab: "Jamg'armalar",
  balanceTotal: "Hisoblarda",
  incomeL: "Daromad",
  expenseL: "Xarajat",
  netL: "Natija",
  savedShare: "Daromadning {p}% jamg'arildi",
  overspent: "Xarajat daromaddan ko'p",
  cmpFull: "O'tgan oy bilan taqqoslangan",
  cmpPartial: "O'tgan oyning 1–{d} kunlari bilan taqqoslangan",
  accountsTitle: "Hisoblar va kartalar",
  personalAcc: "shaxsiy",
  usdRate: "MB kursi: 1 $ = {rate}",
  noRateShort: "MB kursi yo'q",
  fxMissing: "MB kursi yo'q — dollardagi summalar so'mga o'tkazilmadi va jamiga kirmadi.",
  fxMissingDebts: "Dollardagi qarzlar summalarga kirmadi: MB kursi yo'q.",
  aiTitle: "SI maslahatlari",
  aiEmpty: "Claude oila daromadi, xarajati va jamg'armalarini tahlil qilib, qayerda tejash, qanday ko'proq jamg'arish va daromadni oshirishni maslahat beradi.",
  aiGet: "Maslahat olish",
  aiRefresh: "Yangilash",
  aiLoading: "Moliyani tahlil qilyapman… bir daqiqagacha vaqt olishi mumkin",
  aiAt: "{date} dagi tahlil",
  aiLimit: "Yangi tahlil — oyiga bir marta",
  aiNext: "Keyingi tahlil — {date} dan",
  "health.good": "Hammasi yaxshi",
  "health.ok": "Ishlash kerak bo'lgan joylar bor",
  "health.risk": "E'tibor talab qiladi",
  impact: "≈ oyiga {amount}",
  dailyTitle: "Kunlik xarajatlar",
  categoriesTitle: "Pul nimaga ketyapti",
  hiddenPersonal: "Boshqalarning shaxsiy xarajatlari",
  hiddenInTotals: "Natijalarda boshqa oila a'zolarining shaxsiy amallari bor ({parts}) — amallar ro'yxatida ular ko'rinmaydi",
  topItems: "Eng ko'p nima sotib olasiz",
  topPlaces: "Qayerda sarflaysiz",
  recentTitle: "Oxirgi amallar",
  allOps: "Oydagi barcha amallar",
  upcoming: "Yaqin to'lovlar",
  noData: "Yozuvlar paydo bo'lishi bilan bu yerda pul nimaga ketayotgani ko'rinadi.",
  offlineData: "Internet yo'q — {time} dagi ma'lumotlar",
  loadError: "Ma'lumotlarni yuklab bo'lmadi",
  times: "{n} marta",
  transferL: "O'tkazma",
  saved: "jamg'arildi",
  until: "{date} gacha",
  "err.insight_limit": "Tahlil oyiga bir marta — keyingisi oyning 1-sanasidan",
  "err.insight_no_data": "Ma'lumot hali kam: bir nechta daromad va xarajat yozing",
  "err.forbidden": "Ruxsat yo'q",
  "err.bad_args": "Kiritilgan ma'lumotlarni tekshiring",
  "err.not_found": "Topilmadi — balki allaqachon o'chirilgan",
  "err.no_account": "Bu valyutada hisob yo'q — uni «Yana → Hisoblar»da qo'shing",
  "err.no_rate": "MB dollar kursi yo'q — summani so'mda yozing yoki keyinroq urinib ko'ring",
  "err.amount_required": "Summani kiriting",
  "err.blocked": "Xizmatga kirish yopilgan",
  receipt: "Chek",
  checkReceipt: "Chek bilan solishtirish",
  scanQr: "Chek QR-kodini skanerlash",
  scanPrompt: "Kamerani chekdagi QR-kodga qarating",
  receiptPhoto: "Chekni suratga olish",
  pasteLink: "QR-koddagi havola",
  check: "Tekshirish",
  reading: "Chekni o'qiyapman…",
  matching: "Ro'yxat bilan solishtiryapman…",
  extra: "Ro'yxatda yo'q edi",
  missing: "Sotib olinmadi",
  total: "Jami",
  saveMark: "Xarajatni saqlash va sotib olinganlarni belgilash",
  saveOnly: "Faqat xarajatni saqlash",
  receiptSaved: "Xarajat saqlandi",
  alreadySaved: "Bu chek allaqachon saqlangan",
  needOnline: "Chek uchun internet kerak",
  "err.receipt_qr_invalid": "Bu fiskal chek QR-kodi emas",
  "err.receipt_not_found": "Soliq bu chekni topmadi. Keyinroq urinib ko'ring yoki suratga oling",
  "err.receipt_unavailable": "Chekni tekshirish xizmati ishlamayapti — chekni suratga oling",
  "err.receipt_unreadable": "Rasmdagi chekni o'qib bo'lmadi",
  "err.receipt_refund": "Bu qaytarish cheki — xarajat sifatida yozilmaydi",
  "err.receipt_is_payment": "Bu chek emas, o'tkazma skrinshoti — uni botga yuboring",
  "err.generic": "Nimadir xato ketdi",
  opsTab: "Tarix",
  moreTab: "Yana",
  expense: "Xarajat",
  income: "Daromad",
  transfer: "O'tkazma",
  addOp: "Yozish",
  newOp: "Yangi yozuv",
  amount: "Summa",
  category: "Toifa",
  allCategories: "Hammasi",
  toWhom: "Kimga",
  commentPh: "Izoh: do'kon, nima olindi",
  date: "Sana",
  today: "Bugun",
  yesterday: "Kecha",
  otherDate: "Boshqa",
  personalOp: "🔒 Shaxsiy — faqat menga ko'rinadi",
  byPhrase: "✨ Gap bilan yozish",
  byForm: "← Qo'lda to'ldirish",
  phrasePh: "Masalan: taksi 25 ming va qahva 18 000",
  phraseHint: "Bir nechta amalni birdan yozish mumkin — botga xabar kabi",
  recognize: "Aniqlash",
  recognizing: "Aniqlayapman… bir necha soniya",
  saveAll: "Saqlash ({n})",
  notRecognized: "Aniqlab bo'lmadi. Summani va nimaga sarflanganini yozing",
  noOtherAdults: "O'tkazadigan odam yo'q: oilada boshqa kattalar yo'q",
  savedOk: "Saqlandi",
  deletedOk: "O'chirildi",
  fillAmount: "Summani kiriting",
  pickCategory: "Toifani tanlang",
  pickMember: "Kimga o'tkazishni tanlang",
  fillName: "Nomini kiriting",
  needOnlineOp: "Internet yo'q — internet paydo bo'lganda urinib ko'ring",
  opDetails: "Amal",
  author: "Kim yozdi",
  source: "Manba",
  "src.manual": "Ilovada qo'lda",
  "src.text": "Matn bilan (SI tahlili)",
  "src.voice": "Ovozli xabar",
  "src.photo": "Skrinshot yoki rasm",
  "src.receipt": "Chek",
  "src.recurring": "Muntazam to'lov",
  deleteOp: "Amalni o'chirish",
  confirmDeleteOp: "Bu amal o'chirilsinmi? Balans qayta hisoblanadi.",
  personalMark: "Shaxsiy",
  you: "siz",
  all: "Hammasi",
  incomes: "Daromadlar",
  expenses: "Xarajatlar",
  transfers: "O'tkazmalar",
  noOps: "Bu oyda amallar yo'q",
  noOpsHint: "Xarajatlarni pastdagi tugma bilan yozing yoki shunchaki botga yozing",
  firstOp: "Amal yozish",
  newGoal: "Yangi jamg'arma",
  goalName: "Nima uchun jamg'aramiz",
  goalNamePh: "Masalan: velosiped",
  goalTarget: "Qancha kerak",
  deadlineOpt: "Muddat (ixtiyoriy)",
  goalOwner: "Kimning jamg'armasi",
  familyGoal: "Oilaviy",
  myGoal: "Meniki",
  topUp: "To'ldirish",
  withdraw: "Yechib olish",
  goalReached: "🎉 Maqsadga erishildi!",
  left: "{amount} qoldi",
  createGoal: "Jamg'arma yaratish",
  noGoalsYet: "Hozircha jamg'armalar yo'q",
  noGoalsHint: "Butun oila bilan jamg'aring: velosiped, ta'til, sovg'a",
  noGoalsChild: "Orzuing uchun jamg'ar: jamg'arma yarat va oz-ozdan yig'",
  "err.goal_insufficient": "Jamg'armada buncha pul yo'q",
  recurringTitle: "Muntazam to'lovlar",
  addRecurring: "To'lov qo'shish",
  recurringName: "Nima to'lanadi",
  recurringNamePh: "Masalan: internet",
  dayOfMonth: "Oyning qaysi kuni",
  everyMonth: "har oyning {d}-kuni",
  nextOn: "keyingisi {date}",
  noRecurring: "To'lovlar yo'q. Internet, bog'cha, kreditni qo'shing — bot oldindan eslatadi",
  confirmDeleteRecurring: "«{name}» to'lovi o'chirilsinmi?",
  manage: "Boshqarish",
  addAccount: "Hisob qo'shish",
  accountName: "Nomi",
  accountNamePh: "Masalan: Humo, naqd pul",
  currency: "Valyuta",
  personalAccount: "🔒 Shaxsiy — faqat menga ko'rinadi",
  familyTitle: "Oila",
  "role.admin": "administrator",
  "role.adult": "katta",
  "role.child": "bola",
  inviteAdult: "Kattani taklif qilish",
  inviteChild: "Bolani taklif qilish",
  inviteText: "Xarajatlar hisobi botidagi oilamizga qo'shil",
  inviteReady: "Havolani oila a'zosiga yuboring. {date} gacha amal qiladi",
  inviteCode: "Yoki bot uchun kod: {code}",
  share: "Ulashish",
  copy: "Nusxa olish",
  copied: "Nusxa olindi",
  onlyAdminInvites: "Faqat oila administratori taklif qila oladi",
  language: "Til",
  openBot: "Bot bilan chatni ochish",
  help: "Qanday foydalanish",
  devPanel: "Dasturchi paneli",
  sectionMoney: "Pul",
  sectionFamily: "Oila va sozlamalar",
  "help.add.t": "Xarajat yoki daromadni yozish",
  "help.add.d": "Bosh sahifada — katta «＋ Yozish» tugmasi. Botga «taksi 25 000» deb yozish yoki ovozli xabar yuborish kifoya.",
  "help.phrase.t": "Gap bilan, botga yozgandek",
  "help.phrase.d": "Yozish oynasida «✨ Gap bilan yozish»ni bosing — SI summa va toifani o'zi aniqlaydi, siz tekshirib saqlaysiz.",
  "help.receipt.t": "Cheklar",
  "help.receipt.d": "Botga chek rasmi yoki QR-kodini yuboring. Xaridlar ro'yxatidagi 🧾 tugmasi chekni ro'yxat bilan solishtiradi.",
  "help.lists.t": "Xaridlar ro'yxati",
  "help.lists.d": "«Ro'yxatlar» bo'limi: butun oila uchun umumiy ro'yxat, belgilar hammaga darhol ko'rinadi, internetsiz ham ishlaydi. Tayyor to'plamlar — «Shablondan boshlash» bo'limida.",
  "help.goals.t": "Jamg'armalar va to'lovlar",
  "help.goals.d": "Jamg'armalar, muntazam to'lovlar va bolalarning cho'ntak puli — «Yana» bo'limida. Bot to'lovni bir kun oldin eslatadi.",
  "help.sync.t": "Bot va ilova — bir butun",
  "help.sync.d": "Botda yozilgan hamma narsa bu yerda darhol ko'rinadi va aksincha. Botda oxirgi yozuvni bekor qilish — /undo.",
  adminTitle: "Dasturchi paneli",
  adminOverview: "Umumiy",
  adminFamilies: "Oilalar",
  adminUsers: "Odamlar",
  usersL: "Foydalanuvchilar",
  familiesL: "Oilalar",
  activeToday: "Bugun",
  active7: "7 kun",
  active30: "30 kun",
  activeUsers: "Faol foydalanuvchilar",
  newUsers7: "haftada +{n}",
  blockedN: "bloklangan: {n}",
  active7Families: "haftada faol: {n}",
  llmToday: "SI bugun",
  llm30: "SI 30 kunda",
  callsN: "{n} ta so'rov",
  tokensLine: "tokenlar: {in} kirish · {out} chiqish · {cache} keshdan",
  byPurpose: "Vazifalar bo'yicha",
  byModel: "Modellar bo'yicha",
  "purpose.parse": "Xabarlarni tahlil qilish",
  "purpose.ocr": "Rasm va cheklar",
  "purpose.match": "Chekni ro'yxat bilan solishtirish",
  "purpose.advice": "SI maslahatlari",
  activity30: "30 kunlik faollik",
  metricActive: "Odamlar",
  metricRequests: "So'rovlar",
  metricTx: "Amallar",
  metricCost: "$ SI",
  contentTitle: "Ma'lumotlar",
  contentLine: "Amallar: {tx} · cheklar: {r} · ro'yxatlar: {l} · mahsulotlar: {i}",
  block: "Bloklash",
  unblock: "Blokdan chiqarish",
  blockedBadge: "bloklangan",
  blockFamily: "Oilani bloklash",
  unblockFamily: "Oilani blokdan chiqarish",
  confirmBlockUser: "{name} bloklansinmi? Bot va ilova u uchun ishlamay qoladi.",
  confirmBlockFamily: "«{name}» oilasidagi hamma bloklansinmi?",
  lastSeen: "oxirgi marta {when}",
  neverSeen: "hali kirmagan",
  noFamilyL: "oilasiz",
  searchPh: "Ism yoki @username bo'yicha qidirish",
  developerBadge: "dasturchi",
  requests30: "30 kunda so'rovlar: {n}",
  membersN: "{n} kishi",
  txN: "amallar: {n}",
  activeAgo: "faollik {when}",
  noActivity: "hali faollik bo'lmagan",
  updatedAt: "Yangilangan {time}",
  justNow: "hozirgina",
  minAgo: "{n} daqiqa oldin",
  hoursAgo: "{n} soat oldin",
  notFound: "Hech narsa topilmadi",
  appTitle: "Oila byudjeti",
  debtsTitle: "Kreditlar va muddatli to'lovlar",
  debtsShort: "Qarzlar",
  addDebt: "Kredit yoki muddatli to'lov qo'shish",
  newDebt: "Yangi qarz",
  noDebts: "Kreditlar va muddatli to'lovlar yo'q",
  noDebtsHint: "Ularni qo'shing — ilova qoldiqni hisoblaydi, to'lovlarni eslatadi va qarzlar qachon yopilishini ko'rsatadi",
  "debtKind.credit": "Kredit",
  "debtKind.microloan": "Mikroqarz",
  "debtKind.installment": "Muddatli to'lov",
  "debtKind.card": "Kredit karta",
  "debtKind.personal": "Tanishlardan qarz",
  debtNamePh: "Masalan: Anorbank, telefon muddatli to'lovga",
  lender: "Kreditor (ixtiyoriy)",
  debtPrincipal: "Shartnoma bo'yicha summa",
  rate: "Stavka, yillik %",
  scheduleKind: "Qanday to'laysiz",
  "sched.annuity": "Teng to'lovlar",
  "sched.differentiated": "Kamayib boruvchi",
  "sched.equal": "Foizsiz bo'lib",
  "sched.fixed": "To'lovni bilaman",
  termMonths: "Muddat, oy",
  monthlyPayment: "Oylik to'lov",
  startDate: "Boshlanish sanasi",
  paymentDay: "To'lov kuni",
  disbursed: "Pul hisobga tushdi",
  disbursedHint: "Summa hisob qoldig'iga qo'shiladi, lekin daromad hisoblanmaydi",
  personalDebt: "🔒 Shaxsiy — faqat menga ko'rinadi",
  preview: "To'lov ≈ {payment} · {count} oy · ortiqcha to'lov {interest}",
  previewPast: "O'tgan to'lovlar: {n} — ularni xarajat yozmasdan to'langan deb belgilaymiz",
  remainingL: "Qoldi",
  monthlyL: "Oylik to'lovlar",
  loadL: "Yuklama: daromadning {pct}%",
  "load.ok": "me'yorda",
  "load.high": "yuqori",
  "load.danger": "xavfli",
  debtFree: "Qarzsiz — {date} dan",
  overdueN: "Muddati o'tgan to'lovlar: {n}",
  nextPaymentL: "Yaqin to'lov",
  paidOf: "{total} dan {paid} tasi to'langan",
  payNext: "{amount} to'lash",
  payOther: "Boshqa summa",
  extraPay: "Muddatidan oldin to'lash",
  extraTerm: "Muddatni qisqartirish",
  extraPayment: "To'lovni kamaytirish",
  extraHint: "Muddatni qisqartirish — kamroq ortiqcha to'lov. To'lovni kamaytirish — har oy yengilroq.",
  scheduleTitle: "To'lovlar jadvali",
  historicPaid: "hisobdan oldin",
  deleteDebt: "Qarzni o'chirish",
  confirmDeleteDebt: "«{name}» o'chirilsinmi? Yozilgan to'lovlar amallarda qoladi.",
  debtClosed: "🎉 Qarz yopildi!",
  interestLeft: "Yana ortiqcha to'laysiz: {amount}",
  endDateL: "oxirgi to'lov {date}",
  toDebt: "→ Kreditlarga",
  overdueL: "muddati o'tgan",
  personalDebtsOthers: "🔒 Boshqalarning shaxsiy qarzlari: {amount}",
  "err.debt_payment_too_small": "To'lov foizdan kam — qarz bunday yopilmaydi. Summa va stavkani tekshiring",
  "err.debt_nothing_due": "Bu qarz bo'yicha to'lanadigan to'lov yo'q",
  "err.debt_closed": "Qarz allaqachon yopilgan",
  "err.already_handled": "Allaqachon belgilangan",
  payoffTitle: "Qaytarish rejasi",
  payoffIntro: "Majburiy to'lovlarga qo'shimcha qancha to'lay olasiz? Qarzlar qachon yopilishini va foizdan qancha tejashingizni ko'rsatamiz.",
  payoffExtra: "Oyiga qo'shimcha",
  payoffNoExtra: "Qo'shimchasiz",
  avalanche: "Ko'chki",
  snowball: "Qor to'pi",
  avalancheHint: "Avval eng qimmat qarz — eng kam ortiqcha to'lov.",
  snowballHint: "Avval eng kichik qarz — tezroq birinchi g'alabalar, tashlab qo'ymaslik osonroq.",
  payoffFree: "Qarzsiz — {date}",
  payoffSaved: "Qo'shimchasizga qaraganda {months} oy oldin va {amount} kam foiz",
  payoffInterest: "Butun muddat uchun foizlar: {amount}",
  payoffNever: "Bunday to'lovlarda qarzlar yopilmaydi — to'lov foizdan kam. Qo'shimchani oshiring.",
  incomeTitle: "Oila daromadi",
  incomeHint: "Oylik taxminiy daromad — amallar tarixi kam bo'lganda kredit yuklamasi va maslahatlar uchun.",
  incomePerMonth: "Oylik daromad",
  incomeDay: "Ish haqi qachon keladi",
  incomeDayNone: "Aniq kuni yo'q",
  setupTitle: "Bir daqiqada sozlang",
  setupHint: "Shunda tahlil, kredit yuklamasi va maslahatlar birinchi kundanoq aniq bo'ladi.",
  setupIncome: "Oila daromadi",
  setupDebts: "Kreditlar va muddatli to'lovlar",
  setupRecurring: "Muntazam to'lovlar",
  setupDone: "Tayyor",
  phraseDebt: "Yangi kredit yoki muddatli to'lovga o'xshaydi — uni «Yana → Kreditlar» bo'limida qo'shing yoki bu gapni botga yozing.",
  noOpsFilter: "Bu oyda bunday amallar yo'q",
  pickDay: "Oyning kunini tanlang",
  youCap: "Siz",
  copyFailed: "Nusxa olib bo'lmadi — matnni qo'lda belgilang",
  noListsChild: "Bu yerda sening ro'yxatlaring bo'ladi: nima sotib olish yoki o'zing bilan olish kerak.",
  "help.child.goals.d": "«Pullarim» bo'limida — hamyoning va jamg'armalaring. Xarajat va sovg'alarni yozib bor, oz-ozdan jamg'ar — shunda yig'ish eng oson.",
  "help.child.sync.d": "Xuddi shuni botda chat pastidagi tugmalar bilan ham qilish mumkin.",
  homeTab: "Bosh sahifa",
  spentIn: "{month} oyidagi xarajatlar",
  morePct: "bir oy oldingidan {p}% ko'p",
  lessPct: "bir oy oldingidan {p}% kam",
  overspentBy: "Xarajat daromaddan {amount} ko'p",
  reportTitle: "Hisobot",
  reportMonth: "Oylik hisobot",
  noOpsYet: "Hozircha hech narsa yozilmagan",
  noOpsYetHint: "«Yozish»ni bosing yoki botga shunchaki yozing: «non 8 ming».",
  detailsTitle: "Sana, izoh",
  change: "O'zgartirish",
  sharedShort: "umumiy",
  personalShort: "🔒 shaxsiy",
  listsTitle: "Xarid ro'yxatlari",
  startFromTemplate: "Shablondan boshlash",
  start: "Boshlash",
  "help.report.t": "Hisobot",
  "help.report.d": "Bosh sahifada «Pul nimaga ketyapti»ni bosing yoki «Yana → Oylik hisobot»ni oching: toifalar, grafiklar, xaridlaringiz narxlari, do'konlar va SI maslahatlari.",
  pricesTitle: "Narxlar",
  pricesEmpty: "Chekni saqlasangiz yoki xaridni og'irligi bilan yozsangiz, narxlar paydo bo'ladi: «kartoshka 3 kg 24 ming».",
  pricesAll: "Barcha mahsulotlar ({n})",
  inflationUp: "Narxlaringiz o'tgan oylarga nisbatan {p}% oshdi",
  inflationDown: "Narxlaringiz o'tgan oylarga nisbatan {p}% kamaydi",
  inflationSame: "Narxlaringiz o'tgan oylarga nisbatan o'zgarmadi",
  inflationHint: "Shu oydagi xaridlar o'tgan uch oy narxlarida. Hisobdagi mahsulotlar: {n}",
  priceUp: "↑ bir oyda {p}%",
  priceDown: "↓ bir oyda {p}%",
  cheaperAt: "arzonroq: {store} — {price}",
  noStore: "cheksiz",
  unitKg: "kg",
  unitL: "l",
  unitPcs: "dona",
  perUnit: "1 {unit} narxi",
  whereCheaper: "3 oyda qayerda arzonroq",
  purchasesTitle: "Xaridlar",
  boughtQty: "{qty} {unit} — {amount}",
  "purpose.products": "Mahsulotlar ma'lumotnomasi",
  "purpose.weekly": "Hafta yakunlari",
  savedOffline: "Internet yo'q — internet paydo bo'lganda yozamiz",
  opsPending: "Yuborilishini kutayotgan yozuvlar: {n}",
  opsSent: "Internetsiz yozuvlar yuborildi",
  opDropped: "Yozuv saqlanmadi: {reason}",
  dueOn: "Muddat: {date}",
  markPaid: "✅ To'landi",
  markPaidHint: "«To'landi» {amount} xarajat yozadi, keyingi to'lov — bir oydan keyin.",
  skipOnce: "Bu safar o'tkazib yuborish",
  confirmSkip: "«{name}» bu safar o'tkazib yuborilsinmi? Xarajat yozilmaydi.",
  paidOk: "Xarajat yozildi",
  skippedOk: "O'tkazib yuborildi",
  fridgeTitle: "Muzlatgich",
  menuTitle: "Haftalik menyu",
  fridgeHave: "Uyda bor",
  fridgeStale: "Ancha oldin olingan — tekshiring",
  fridgeUsed: "Tugadi",
  fridgeUsedHint: "Mahsulot hali bo'lsa, ustiga bosing.",
  fridgeEmpty: "Muzlatgich bo'sh",
  fridgeEmptyHint: "Do'kondan chekni saqlang yoki xaridni mahsulotlari bilan yozing: «sut, non, tuxum 45 ming». Olinganlar shu yerda o'zi paydo bo'ladi — «Tugadi» deb belgilanguncha.",
  usedBtn: "Tugadi",
  toListBtn: "Ro'yxatga",
  addProduct: "Mahsulot qo'shish",
  productName: "Mahsulot",
  productNamePh: "Masalan: sut",
  boughtToday: "bugun olindi",
  boughtYesterday: "kecha olindi",
  boughtDaysAgo: "{n} kun oldin olindi",
  markedUsed: "Belgilandi: tugadi",
  restored: "Muzlatgichga qaytarildi",
  addedToList: "«{name}» ro'yxatiga qo'shildi",
  groceryListName: "Oziq-ovqat",
  menuListName: "Haftalik menyu",
  cookIdeas: "Nima pishiramiz?",
  ideasTitle: "Pishirish mumkin",
  ideasLoading: "Taomlarni tanlayapmiz — 5–10 soniya…",
  ideasMore: "Boshqa variantlar",
  ideaHave: "Bor: {list}",
  ideaMissing: "Sotib olish: {list}",
  minutesN: "{n} daq",
  menuEmptyHint: "Uyda borlaridan 7 kunlik tushlik va kechki ovqat hamda nima sotib olish kerakligini tuzamiz.",
  wishesL: "Istaklar (ixtiyoriy)",
  wishesPh: "Masalan: qo'ziqorinsiz, bolaga 3 yosh",
  makeMenu: "Menyu tuzish",
  remakeMenu: "Qaytadan tuzish",
  menuLoading: "Menyu tuzilmoqda — 10–20 soniya…",
  lunchL: "Tushlik",
  dinnerL: "Kechki ovqat",
  shoppingN: "Nima sotib olish kerak ({n})",
  toShoppingList: "Xaridlar ro'yxatiga",
  weekdaysFull: "dushanba,seshanba,chorshanba,payshanba,juma,shanba,yakshanba",
  "err.pantry_empty": "Uyda hozircha hech narsa belgilanmagan — chekni saqlang yoki mahsulot qo'shing",
  "err.ai_limit": "Bugunga g'oyalar yetarli — ertaga urinib ko'ring",
  "err.ai_unavailable": "SI hozir javob bermadi — bir daqiqadan keyin qayta urinib ko'ring",
  "purpose.cooking": "Nima pishiramiz",
  "purpose.menu": "Haftalik menyu",
  "help.cook.t": "Muzlatgich va menyu",
  "help.cook.d": "«Yana → Uy → Muzlatgich»: cheklar bo'yicha olinganlar o'zi paydo bo'ladi, «Tugadi» deb belgilang. SI nima pishirishni maslahat beradi va haftalik menyu tuzadi — yetishmaganlar bir tugma bilan xaridlar ro'yxatiga tushadi.",
  sectionHome: "Uy",
  "help.home.t": "Dori qutisi va kafolatlar",
  "help.home.d": "«Yana → Uy»: yaroqlilik muddati bilan dorilar va chek surati bilan kafolatli xaridlar. Muddatdan bir oy oldin bot eslatadi.",
  kitTitle: "Dori qutisi",
  warrantiesTitle: "Kafolatlar",
  kitEmpty: "Dori qutisi bo'sh",
  kitEmptyHint: "Dorilarni yaroqlilik muddati bilan qo'shing — muddat tugashiga bir oy qolganda bot eslatadi.",
  warrantiesEmpty: "Hozircha kafolatlar yo'q",
  warrantiesEmptyHint: "Xaridni chek surati va kafolat muddati bilan saqlang — tugashiga bir oy qolganda bot eslatadi.",
  addMedicine: "Dori qo'shish",
  addWarranty: "Kafolat qo'shish",
  medicineName: "Dori",
  medicineNamePh: "Masalan: Nurofen bolalar uchun",
  warrantyName: "Nima olindi",
  warrantyNamePh: "Masalan: Artel muzlatgichi",
  expiresMonth: "Yaroqlilik muddati (qutidagidek)",
  boughtOnL: "Xarid sanasi",
  warrantyFor: "Kafolat",
  warrantyMonths: "{n} oy",
  warrantyYears: "{n} yil",
  warrantyOther: "Boshqa muddat",
  warrantyUntil: "Kafolat {date} gacha",
  untilDate: "Qaysi sanagacha",
  fillBoughtOn: "Xarid sanasini kiriting yoki «Boshqa muddat»ni tanlang",
  fillUntil: "Kafolat qaysi sanagacha ekanini kiriting",
  medicineNote: "Nima uchun, qancha qoldi",
  medicineNotePh: "Masalan: isitmaga qarshi, 1 quti",
  warrantyNote: "Qayerdan olindi, servis",
  warrantyNotePh: "Masalan: Mediapark, servis markazi",
  warrantyPhoto: "Chek yoki talon surati",
  packPhoto: "Quti surati",
  expiredMedicine: "Muddati o'tgan",
  expiredWarranty: "Tugagan",
  inDaysN: "{n} kundan keyin",
  todayLast: "bugun oxirgi kun",
  monthsLeftN: "yana {n} oy",
  usedUp: "Tugadi",
  confirmUsedUp: "«{name}» dori qutisidan olib tashlansinmi?",
  confirmDeleteWarranty: "«{name}» kafolati o'chirilsinmi?",
  expiredWarranties: "Tugaganlar",
  photoTap: "Suratni ochish uchun bosing",
  pocketTab: "Pullarim",
  walletTitle: "Hamyonda",
  spendBtn: "Xarajat",
  saveBtn: "Jamg'arish",
  giftBtn: "Menga berishdi",
  spendTitle: "Xarajatni yozish",
  giftTitle: "Senga pul berishdi",
  saveTitle: "Jamg'arma",
  spendNote: "Nimaga",
  spendNotePh: "Masalan: muzqaymoq",
  giftNote: "Kimdan",
  giftNotePh: "Masalan: buvim",
  toGoal: "Jamg'arish",
  fromGoal: "Hamyonga olish",
  pickGoal: "Qaysi jamg'armaga",
  allowanceEvery: "Cho'ntak puli: {amount} {weekday}",
  allowanceNext: "keyingisi — {date}",
  weekdaysEvery: "har dushanba,har seshanba,har chorshanba,har payshanba,har juma,har shanba,har yakshanba",
  weekdaysShort: "Du,Se,Ch,Pa,Ju,Sh,Ya",
  thisMonth: "Shu oyda",
  gotL: "Olindi",
  spentL: "Sarflandi",
  savedL: "Jamg'arildi",
  tipOfWeek: "Hafta maslahati",
  pocketHistory: "Nima bo'ldi",
  pocketEmpty: "Bu yerda pullaring bo'ladi",
  pocketEmptyHint: "Cho'ntak puli, sovg'alar va xarajatlar. Puling bo'lsa — «Menga berishdi»ni bos.",
  "pocket.give": "Cho'ntak puli",
  "pocket.gift": "Sovg'a",
  "pocket.spend": "Xarajat",
  "pocket.saveIn": "«{name}» jamg'armasiga",
  "pocket.saveOut": "«{name}» jamg'armasidan",
  goalPace: "Haftasiga {amount} — yana {n} hafta",
  inWallet: "Hamyonda: {amount}",
  showAllN: "Hammasini ko'rsatish ({n})",
  confirmDeleteEntry: "«{what}» yozuvi o'chirilsinmi?",
  "err.pocket_insufficient": "Hamyonda buncha pul yo'q",
  "err.pocket_spent": "Bu pul allaqachon sarflangan — avval xarajatlarni o'chiring",
  "err.pocket_currency": "Hamyondan faqat so'mdagi jamg'armaga solish mumkin",
  pocketMoney: "Cho'ntak puli",
  noKids: "Oilada hozircha bolalar yo'q. Bolani taklif qiling: «Yana → Oila».",
  giveBtn: "Berish",
  giveTitle: "Cho'ntak puli berish",
  giveHint: "Umumiy hisobdan oilaning «Bolalar» xarajati bo'lib yoziladi.",
  givenOk: "Berildi",
  allowanceTitle: "Har hafta",
  allowanceNone: "Jadval bo'yicha cho'ntak puli sozlanmagan",
  allowanceSetup: "Sozlash",
  allowanceDay: "Qaysi kuni",
  allowanceTurnOff: "O'chirish",
  allowanceHint: "Pul bolaga o'zi keladi — bot unga ham, sizga ham xabar beradi. Oila xarajatlarida «Bolalar» yozuvi paydo bo'ladi.",
  allowanceSaved: "Cho'ntak puli sozlandi",
  allowanceOffOk: "Cho'ntak puli o'chirildi",
  stashAccount: "🐷 Zaxira — faqat menga ko'rinadi, umumiy qoldiqqa kirmaydi",
  defaultBadge: "asosiy",
  stashSection: "🐷 Zaxira — umumiy qoldiqqa kirmaydi",
  balanceParts: "Qoldiq nimadan iborat",
  partOpening: "Boshlang'ich qoldiq va tekshiruvlar",
  partIncome: "Daromadlar",
  partExpense: "Xarajatlar",
  partTransfersIn: "Hisobga o'tkazmalar",
  partTransfersOut: "Hisobdan o'tkazmalar",
  partCredits: "Kredit pullari",
  partGoals: "Jamg'armalarga ajratilgan",
  reconcile: "Qoldiqni tekshirish",
  reconcileHint: "Hisobda aslida qancha bor? Farq boshlang'ich qoldiqqa yoziladi — daromad va xarajatlar o'zgarmaydi.",
  actualBalance: "Hozirgi qoldiq",
  reconciledOk: "Qoldiq tekshirildi",
  negativeBalance: "Hisob minusda (overdraft)",
  renameAccount: "Nomini o'zgartirish",
  makeStash: "🐷 Zaxira qilish",
  unmakeStash: "Umumiy qoldiqqa qaytarish",
  stashOnOk: "Endi bu zaxira",
  stashOffOk: "Hisob yana umumiy qoldiqda",
  accountOps: "Hisob bo'yicha amallar",
  noAccountOps: "Hisob bo'yicha hali amallar yo'q",
  accountL: "Hisob",
  fromAccount: "Qaysi hisobdan",
  toAccount: "Qaysi hisobga",
  transferMember: "👤 Oila a'zosiga",
  transferOwn: "💳 Hisoblar orasida",
  received: "Qancha tushdi",
  receivedHint: "Bo'sh qolsa — MB kursi bo'yicha hisoblaymiz",
  commission: "Komissiya, agar bo'lgan bo'lsa",
  commissionNote: "komissiya",
  pickFromAccount: "Qaysi hisobdan ekanini tanlang",
  pickToAccount: "Qaysi hisobga ekanini tanlang",
  moveAccount: "Boshqa hisobga o'tkazish",
  movedOk: "«{name}» hisobiga o'tkazildi",
  receivedL: "Tushdi",
  "err.account_currency": "Hisob boshqa valyutada — amal valyutasidagi hisobni tanlang",
  "err.same_account": "«Qayerdan» va «qayerga» hisobi bir xil",
  makePersonalOp: "🔒 Shaxsiy qilish",
  makeSharedOp: "👨‍👩‍👧 Umumiy qilish",
  madePersonalOk: "Endi faqat sizga ko'rinadi",
  madeSharedOk: "Endi oilaga ko'rinadi",
  fridgeSoon: "Tez orada tugaydi",
  lastsDays: "{n} kunga yetadi",
  dueSoon: "tez orada tugaydi",
  dueNow: "sotib olish vaqti",
  suggestTitle: "Sotib olish vaqti",
  needToList: "Xaridlar ro'yxatiga qo'shish",
  versionLabel: "Versiya {v}",
  versionStale: "Serverda allaqachon {v} — ilovani yopib, qayta oching",
  rhythmEvery: "Odatda har {n} kunda olasiz",
  rhythmLast: "oxirgi marta — {day}",
  rhythmNext: "yana — {n} kundan keyin",
  healthTitle: "Bu qanday mahsulot",
  healthHealthy: "🥦 Foydali",
  healthNeutral: "Oddiy",
  healthUnhealthy: "🍭 Zararli",
  healthSaved: "Belgi saqlandi — faqat oilangiz uchun",
  noPricesYet: "Narxlar hozircha yo'q: ular cheklar va summali iboralardan paydo bo'ladi",
  basketTitle: "Savatda nima bor",
  basketHealthy: "Foydali",
  basketNeutral: "Oddiy",
  basketUnhealthy: "Zararli",
  basketUsual: "odatda {p}%",
  basketMore: "🍭 Savatda shirinlik va zararli narsalar odatdagidan ko'p.",
  basketLess: "🥦 Zararli narsalar odatdagidan kam.",
  basketHint: "Oy davomidagi mahsulotlar summasi — cheklardan va mahsulot summasi ko'rsatilgan iboralardan.",
};

export type Lang = "ru" | "uz";

function pluralForm(forms: string[], n: number): string {
  const [one, few = one, many = few] = forms as [string, string?, string?];
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}
let current: Lang = "ru";

export function getLang(): Lang {
  return current;
}

export function setLang(lang: Lang) {
  current = lang;
  document.documentElement.lang = lang;
}

export function t(key: Key, params: Record<string, string | number> = {}): string {
  let s = (current === "uz" ? uz : ru)[key];
  if (s.includes("|") && typeof params.n === "number") s = pluralForm(s.split("|"), params.n);
  return s.replace(/\{(\w+)\}/g, (m, k: string) => (k in params ? String(params[k]) : m));
}

/** Перевод, если такой ключ есть (коды ошибок сервера и т.п.). */
export function tryT(key: string, params: Record<string, string | number> = {}): string | null {
  return key in ru ? t(key as Key, params) : null;
}

export function kindLabel(kind: ListKind): string {
  return t(`kind.${kind}`);
}

export const KIND_ICONS: Record<ListKind, string> = { grocery: "🛒", pharmacy: "💊", kids: "🧸", other: "📦" };

/** Внутренние коды единиц (как в боте и чеках) и их подписи. */
export const UNIT_CODES = ["pcs", "kg", "g", "l", "pack"] as const;
export function unitLabel(code: string | null): string {
  if (!code) return "";
  const idx = UNIT_CODES.indexOf(code as (typeof UNIT_CODES)[number]);
  return idx === -1 ? code : (t("units").split(",")[idx] ?? code);
}
